var link_viewer_default = {
  "fontElementMap": "beBAJ",
  "link": "RtUmt",
  "linkInEditor": "w3USL",
  "linkInViewer": "XgxHi",
  "toolbarUrlContainer": "eVqMH",
  "toolbarUrl": "nZhjc",
  "toolbarUrlAnchor": "Leajh"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
